import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJfrogbintrayComponent } from './simple-icons-jfrogbintray.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJfrogbintrayComponent ],
    exports:      [ SimpleIconsJfrogbintrayComponent ],
    bootstrap:    []
})
export class SimpleIconsJfrogbintrayModule {}
